<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="pagebody">
      <!-- 搜索过滤栏 -->
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" label-width="90px">
            <el-row>
              <el-col :span="18">
                <el-form-item label="角色名称：" prop="role_name">
                  <el-input v-model="searchForm.role_name" placeholder="请输入角色名称" style="width: 160px" />
                </el-form-item>
              </el-col>
              <el-col :span="6" style="text-align: right; padding-right: 10px;">
                <el-button type="primary" icon="el-icon-search" size="small" plain @click="handleSearch">查询</el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain @click="handleReset" style="margin-left: 8px">重置</el-button>
                <el-button type="success" icon="el-icon-plus" size="small" plain @click="handleCreate">新增</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <!-- 主表格 -->
      <el-row class="main-table">
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column type="index" label="序号" width="60" align="center" />

          <el-table-column prop="id" label="ID" width="200" show-overflow-tooltip />
          <el-table-column prop="role_name" label="角色名称" width="140" />
          <el-table-column label="状态" width="100">
            <template v-slot="scope">
              <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
                {{ scope.row.status === 0 ? '正常' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
         
          
      
          <el-table-column prop="remark" label="备注" width="120" />
          
          <el-table-column prop="created_by" label="创建者" width="130" />
          
          <el-table-column label="创建时间" width="170">
            <template v-slot="scope">
              {{ formatDateTime(scope.row.created_at) }}
            </template>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column  label="操作" width="200" align="center">
            <template v-slot="scope">
              <el-button type="text" size="mini" @click="editRole(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click="delRole(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <!-- 分页 -->
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="pagination.pageSizeList"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </el-row>
    </el-row>

    <!-- 新增/编辑组件 -->
    <create-role ref="createRole" @success="getTableData" />
    <edit-role ref="editRole" @success="getTableData" />
  </d2-container>
</template>

<script>
import CreateRole from '../roleUser/CreateRole.vue';
import EditRole from '../roleUser/EditRole.vue';
import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";
import util from '@/libs/util.js'; // 假设 util.js 是项目自定义工具库
import { MessageBox } from 'element-ui';

export default {
  name: 'UserList',
  components: {
    topLine,
    CreateRole,
    EditRole
  },
  data() {
    return {
      pageTitle: '角色列表',
      loading: false,
      searchForm: {
        account: '',
        username: '',
        status: '',
        type: '',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        total: 0,
      },
      tableData: [],
      tableDataApi: '/api-30216/api/roles'
    };
  },
  mounted() {
    this.loadParams();
    this.getTableData();
  },
  methods: {
    loadParams() {
      const { page, pageSize } = this.$route.query;
      if (page) this.pagination.page = parseInt(page, 10);
      if (pageSize) this.pagination.pageSize = parseInt(pageSize, 10);
    },

    getTableData() {
      this.loading = true;
      const params = { ...this.searchForm, ...this.pagination };

      this.$axios.get(this.tableDataApi, { params })
        .then(res => {
          this.tableData = res.data || [];
          this.pagination.total = res.total || 0;
          this.loading = false;
        })
        .catch(err => {
          console.error('获取用户列表失败：', err);
          this.$message.error('数据加载失败');
          this.loading = false;
        });
    },

    formatGender(val) {
      const map = { 0: '未知', 1: '男', 2: '女' };
      return map[val] || '未知';
    },

    formatUserType(val) {
      const map = { 0: '平台管理员', 1: '租户管理员', 2: '普通用户' };
      return map[val] || '未知';
    },
    getTypeTag(val) {
      return ['warning', 'success', 'info'][val] || 'info';
    },

    // ✅ 修复关键错误：替换 formatDate 为实际存在的方法或使用原生 Date API
    formatDateTime(datetime) {
      if (!datetime) return '';
      
      // 方案一：如果 util.js 中有 format 或其他日期方法，请替换正确函数名
      // return util.format(datetime, 'YYYY-MM-DD HH:mm:ss'); 
      
      // 方案二（推荐）：使用 JavaScript 原生 Date 对象格式化
      const date = new Date(datetime);
      if (isNaN(date.getTime())) return ''; // 防止无效日期
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    handleSearch() {
      this.pagination.page = 1;
      this.$router.push({
        query: {
          ...this.searchForm,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
      }).catch(err => {
        // ✅ 已处理 NavigationDuplicated 错误
        if (err.name !== 'NavigationDuplicated') {
          console.error('Unexpected routing error:', err);
        }
      });
      this.getTableData();
    },

    handleReset() {
      this.searchForm = {
        account: '',
        username: '',
        email: '',
        phone: '',
        status: '',
        type: '',
        page: 1,
        pageSize: 10
      };
      this.pagination.page = 1;
      this.handleSearch();
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.handleSearch();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.handleSearch();
    },

    handleCreate() {
      this.$refs.createRole.open();
    },

    editRole(row) {
      // if (this.$refs.editRole && typeof this.$refs.editRole.openDialog === 'function') {
      //   this.$refs.editRole.openDialog(row);
      // }
      this.$refs.editRole.open(row);
    },

    delRole(row) {
       MessageBox.confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         this.$axios.delete(`/api-30216/api/roles/${row.id}`).then(response => {
          if (response.code === 200) {
            this.$message.success(response.message || '删除成功');
          } else {
            this.$message.error(response.message || '删除失败');
          }
          this.getTableData();
        }).catch(error => {
          console.error(error);
          this.$message.error('删除失败，请检查网络或服务状态');
        });
        
      }).catch(() => {
        // 用户点击“取消”或关闭弹窗时触发
        this.$message.info('已取消删除');
      });
    }
  }
}
</script>

<style scoped lang="scss"> 
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>